import { render, staticRenderFns } from "./page.vue?vue&type=template&id=436dc4a0&scoped=true&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"
import style0 from "./page.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./page.vue?vue&type=style&index=1&id=436dc4a0&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "436dc4a0",
  null
  
)

export default component.exports